const updateTeamMemberFeatured = (block, card) => {
	const rawData = card.getAttribute('data-member');

	if (!rawData) {
		console.warn('No data-member found on clicked team card.');
		return;
	}

	let member;

	try {
		member = JSON.parse(rawData);
	} catch (error) {
		console.error('Could not parse team member JSON:', error, rawData);
		return;
	}

	const cards = block.querySelectorAll('[data-team-card]');
	const featuredImage = block.querySelector('[data-team-featured-image]');
	const featuredEyebrow = block.querySelector('[data-team-featured-eyebrow]');
	const featuredName = block.querySelector('[data-team-featured-name]');
	const featuredRole = block.querySelector('[data-team-featured-role]');
	const featuredTags = block.querySelector('[data-team-featured-tags]');
	const featuredFacts = block.querySelector('[data-team-featured-facts]');

	cards.forEach((item) => {
		item.classList.remove('is-active');
		item.setAttribute('aria-pressed', 'false');
	});

	card.classList.add('is-active');
	card.setAttribute('aria-pressed', 'true');

	if (featuredImage && member.featuredImage) {
		featuredImage.src = member.featuredImage;
		featuredImage.alt = member.featuredImageAlt || member.name || '';
	}

	if (featuredEyebrow) {
		featuredEyebrow.textContent = member.eyebrow || '';
		featuredEyebrow.classList.toggle('is-hidden', !member.eyebrow);
	}

	if (featuredName) {
		featuredName.textContent = member.name || '';
	}

	if (featuredRole) {
		featuredRole.textContent = member.role || '';
		featuredRole.classList.toggle('is-hidden', !member.role);
	}

	if (featuredTags) {
		featuredTags.innerHTML = '';

		if (Array.isArray(member.tags)) {
			member.tags.forEach((tag) => {
				const tagEl = document.createElement('span');
				tagEl.className = 'team-members-block__tag';
				tagEl.textContent = tag;
				featuredTags.appendChild(tagEl);
			});
		}
	}

	if (featuredFacts) {
		featuredFacts.innerHTML = '';

		if (Array.isArray(member.facts)) {
			member.facts.forEach((fact) => {
				const factEl = document.createElement('p');
				factEl.className = 'team-members-block__fact';

				if (fact.label) {
					const labelEl = document.createElement('strong');
					labelEl.textContent = `${fact.label}: `;
					factEl.appendChild(labelEl);
				}

				if (fact.value) {
					const valueEl = document.createElement('span');
					valueEl.textContent = fact.value;
					factEl.appendChild(valueEl);
				}

				featuredFacts.appendChild(factEl);
			});
		}
	}
};

const initTeamMembersBlocks = () => {
	const blocks = document.querySelectorAll('[data-team-members-block]');

	blocks.forEach((block) => {
		if (block.dataset.teamMembersInitialized === 'true') {
			return;
		}

		block.dataset.teamMembersInitialized = 'true';

		const slider = block.querySelector('[data-team-slider]');
		const cards = Array.from(block.querySelectorAll('[data-team-card]'));
		const prevButton = block.querySelector('[data-team-prev]');
		const nextButton = block.querySelector('[data-team-next]');

		if (!slider || !cards.length) {
			return;
		}

		/**
		 * Main selection behaviour.
		 * This should always work on desktop and mobile.
		 */
		cards.forEach((card) => {
			card.addEventListener('click', (event) => {
				event.preventDefault();
				updateTeamMemberFeatured(block, card);
			});
		});

		/**
		 * Arrow scrolling.
		 */
		if (prevButton) {
			prevButton.addEventListener('click', (event) => {
				event.preventDefault();

				slider.scrollBy({
					left: -slider.clientWidth * 0.8,
					behavior: 'smooth',
				});
			});
		}

		if (nextButton) {
			nextButton.addEventListener('click', (event) => {
				event.preventDefault();

				slider.scrollBy({
					left: slider.clientWidth * 0.8,
					behavior: 'smooth',
				});
			});
		}

		/**
		 * Drag scrolling only if the carousel actually overflows.
		 * This avoids desktop clicks getting swallowed when the cards fit.
		 */
		let isDragging = false;
		let hasDragged = false;
		let startX = 0;
		let startScrollLeft = 0;

		const carouselCanScroll = () => {
			return slider.scrollWidth > slider.clientWidth + 4;
		};

		slider.addEventListener('pointerdown', (event) => {
			if (!carouselCanScroll()) {
				return;
			}

			if (event.button !== undefined && event.button !== 0) {
				return;
			}

			isDragging = true;
			hasDragged = false;
			startX = event.clientX;
			startScrollLeft = slider.scrollLeft;

			slider.classList.add('is-dragging');
		});

		slider.addEventListener('pointermove', (event) => {
			if (!isDragging) {
				return;
			}

			const distance = event.clientX - startX;

			if (Math.abs(distance) > 8) {
				hasDragged = true;
				slider.scrollLeft = startScrollLeft - distance;
			}
		});

		slider.addEventListener(
			'click',
			(event) => {
				if (!hasDragged) {
					return;
				}

				event.preventDefault();
				event.stopPropagation();

				window.setTimeout(() => {
					hasDragged = false;
				}, 100);
			},
			true
		);

		const stopDragging = () => {
			if (!isDragging) {
				return;
			}

			isDragging = false;
			slider.classList.remove('is-dragging');

			window.setTimeout(() => {
				hasDragged = false;
			}, 100);
		};

		slider.addEventListener('pointerup', stopDragging);
		slider.addEventListener('pointercancel', stopDragging);
		slider.addEventListener('mouseleave', stopDragging);
	});
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initTeamMembersBlocks);
} else {
	initTeamMembersBlocks();
}
